import { render, staticRenderFns } from "./ContentSelectionSundayResultsDesktop.vue?vue&type=template&id=1f43801e&scoped=true&"
import script from "./ContentSelectionSundayResultsDesktop.vue?vue&type=script&lang=js&"
export * from "./ContentSelectionSundayResultsDesktop.vue?vue&type=script&lang=js&"
import style0 from "./ContentSelectionSundayResultsDesktop.vue?vue&type=style&index=0&id=1f43801e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f43801e",
  null
  
)

export default component.exports